import { BACKGROUND_TYPE, HOLDER_URL } from '@/constants';

export function getBackgroundByType(
  settings: {
    [x: string]: any;
  },
  backgroundType: string,
  color: string,
  gradient: string,
  image: string,
  defaultColor = '#fff',
  defaultImage = HOLDER_URL,
) {
  const settingsBackgroundType: BACKGROUND_TYPE | null = settings?.[backgroundType];

  switch (settingsBackgroundType) {
    case BACKGROUND_TYPE.COLOR:
      return settings?.[color] ?? defaultColor;
    case BACKGROUND_TYPE.IMAGE:
      return `url('${settings?.[image] ?? defaultImage}')`;
    case BACKGROUND_TYPE.GRADIENT:
      return settings?.[gradient];
    default:
      return 'initial';
  }
}
